import React from "react";
import type { ProxyUser } from "../types/global";
import type { UserType } from "../utils/constant";

export const AppContext = React.createContext<{
  loginState: {
    status: string;
    token: string;
    user: any;
    userType?: UserType;
    proxyUser?: ProxyUser;
  };
  setLoginState: (state: any) => void;
  cartCount: number;
  setCartCount: (count: number) => void;
  checkedCartItems: Set<any>;
  setCheckedCartItems: (items: any) => void;
  refreshCart: number;
  refreshCartData: () => void;
  cartData: {
    matchStatus: boolean;
    exchangeOrderable?: boolean;
    allowSingleItem?: boolean;
    allowLinearTier?: boolean;
    exceedOrderLimit?: boolean;
    activity: any;
    exchange?: any;
    total: string;
    originalTotal: string;
    savingTotal: string;
    hasFurtherPromotion?: boolean;
    currentTieredRule?: {
      id: number;
      activityId: string;
      activityCondition: string;
      promoTypeValue: string;
      exchangeMaxQty: string;
      exchangePromoTypeValue: string;
    };
    savingDetails?: {
      originalTotal?: string;
      singleSaving?: string;
      combinationSaving?: string;
      total?: string;
    };
  };
  setCartData: (data: any) => void;
  activityPermissionMeta: {
    activityId?: string;
    customerDataType?: string;
  };
  setActivityPermissionMeta: (data: {
    activityId?: string;
    customerDataType?: string;
  }) => void;
  selectedAddressKey: string;
  setSelectedAddressKey: (key: string) => void;
  refetchCustomerDetails: () => void;
}>({
  // idle fetching login failed
  loginState: {
    status: "idle",
    token: "",
    user: { userName: "" },
  },
  setLoginState: (state: any) => {},
  cartCount: 0,
  setCartCount: (count: number) => {},
  refreshCart: 1,
  refreshCartData: () => {},
  checkedCartItems: new Set(),
  setCheckedCartItems: (Set) => {},
  cartData: {
    matchStatus: false,
    activity: {},
    exchange: {},
    total: "",
    originalTotal: "",
    savingTotal: "",
    hasFurtherPromotion: false,
  },
  setCartData: (data: any) => {},
  activityPermissionMeta: {
    activityId: "",
    customerDataType: undefined,
  },
  setActivityPermissionMeta: (data) => {},
  selectedAddressKey: "",
  setSelectedAddressKey: (key: string) => {},
  refetchCustomerDetails: () => {},
});
